import { Button, Card, Input } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";

import { useAppDispatch } from "../../../app/app.store";
import {
  useRequestOtpMutation,
  useVerifyOtpMutation,
} from "../../../app/features/auth/auth.api";
import { verifyUser } from "../../../app/features/auth/auth.slice";
import Banner from "../../../assets/images/loginBanner.svg";
import Logo from "../../../assets/images/Logo.svg";
import { errorToast } from "../../../utils/error.utils";
import RightIcon from "../../web/allCourses/_icons/RightIcon";

export default function Otp() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");

  const handleChange = (value: string) => {
    setOtp(value);
  };

  // State for timer
  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes in seconds
  const [canResend, setCanResend] = useState(false);

  const location = useLocation();
  const dispatch = useAppDispatch();
  const [verifyOtp, { isLoading: isVerifying }] = useVerifyOtpMutation();
  const [requestOtp, { isLoading: isResending }] = useRequestOtpMutation();

  const phone = location.state?.phone;
  const email = location.state?.email;
  const otpChannel = location.state?.otpChannel;

  // Timer logic
  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timerId);
    } else {
      setCanResend(true);
    }
  }, [timeLeft]);

  const formatTime = (seconds: number) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  const handleSubmit = async () => {
    // TODO: phone
    if ((!email && !phone) || !otp) {
      errorToast("Phone or OTP missing", "OTP ভেরিফিকেশন ব্যর্থ হয়েছে");
      return;
    }
    try {
      const res = await verifyOtp({ email, phone, otp, otpChannel }).unwrap();
      if (res.accessToken) {
        dispatch(
          verifyUser({
            accessToken: res.accessToken,
            refreshToken: res.refreshToken,
          })
        );
        navigate("/user/dashboard");
      }
    } catch (error) {
      errorToast(error, "OTP ভেরিফিকেশন ব্যর্থ হয়েছে");
    }
  };

  const handleResendOtp = async () => {
    // TODO: phone
    if (!email && !phone) {
      errorToast("Phone or OTP missing", "OTP ভেরিফিকেশন ব্যর্থ হয়েছে");
      return;
    }
    try {
      await requestOtp({ email, phone, otpChannel }).unwrap();
      setTimeLeft(120);
      setCanResend(false);
    } catch (error) {
      errorToast(error, "OTP পাঠান যায়নি");
    }
  };

  return (
    <div className="flex h-screen flex-col md:flex-row">
      {/* Left side - Banner */}
      <div className="hidden lg:block w-1/2 ">
        <img src={Banner} alt="Banner" className="w-full h-full object-cover" />
      </div>

      {/* Right side - Login card */}
      <div className="w-full lg:w-1/2 relative bg-[#E9F2F2] flex items-center justify-center h-screen md:h-auto">
        {/* Top-left Back button */}
        <div className="absolute top-4 left-4">
          <Button
            type="primary"
            size="middle"
            className="!bg-transparent !border-none !text-[#030D0D] text-lg font-medium"
            onClick={() => navigate("/")}
          >
            <RightIcon className="!text-[#030D0D] text-lg pb-1" /> হোমে ফিরে যান
          </Button>
        </div>

        {/* Centered Card */}
        <Card className="!w-96 shadow-lg sm:w-11/12" bordered={false}>
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img src={Logo} alt="Logo" className="h-14 w-auto" />
          </div>

          <div className="text-theme-zinc-700 text-xl font-semibold mb-4">
            OTP ভেরিফিকেশন
          </div>

          <div className="justify-start text-slate-600 text-sm font-normal mb-6">
            {/* OTP ভেরিফিকেশনের জন্য {phone} নম্বরে ৬ সংখ্যার OTP পাঠানো হয়েছে,
            ইনবক্স/এসএমএস দেখুন{" "} */}
            OTP ভেরিফিকেশনের জন্য {otpChannel === "phone" ? phone : email} এ ৬ সংখ্যার OTP পাঠানো হয়েছে,
            ইনবক্স/এসএমএস দেখুন{" "}
          </div>

          {/* Ant Design OTP Input */}
          <div className="mb-6">
            <Input.OTP
              value={otp}
              onChange={handleChange}
              length={6}
              autoFocus
              size="large"
              className="!gap-2 !justify-center"
            />
          </div>

          <div className="flex justify-between items-center mb-6">
            <Button
              type="link"
              disabled={!canResend || isResending}
              onClick={handleResendOtp}
              className="p-0 text-blue-600 font-normal"
            >
              {isResending ? "পাঠানো হচ্ছে..." : "পুনরায় OTP পাঠান"}
            </Button>
            {!canResend && (
              <span className="text-slate-500">
                {formatTime(timeLeft)} পরে আবার চেষ্টা করুন
              </span>
            )}
          </div>

          <Button
            type="primary"
            onClick={handleSubmit}
            loading={isVerifying}
            block
            size="large"
          >
            লগইন করুন
          </Button>
        </Card>
      </div>
    </div>
  );
}
